import { ru } from "date-fns/locale/ru";
import i18n from "i18next";
import moment from "moment";
import "moment/locale/ru";
import React, { useEffect, useState } from "react";
import { FormControl } from "react-bootstrap";
import DateRangePicker from "react-bootstrap-daterangepicker";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";

import { Awesome } from "@components/Helpers";

import "./WrapperDates.css";

export function WrapperDateRangePicker({ withTime = false, value, onChange }) {
    // https://github.com/skratchdot/react-bootstrap-daterangepicker

    const { t } = useTranslation();
    const [parentEl, setParentEl] = useState(null);

    const fmtInput = withTime ? "DD.MM.YYYY HH:mm:ss" : "DD.MM.YYYY";
    const fmtBackend = withTime ? "YYYY-MM-DD HH:mm:ss" : "YYYY-MM-DD";

    useEffect(() => {
        if (document.getElementById("id-filters-modal")) {
            setParentEl("#id-filters-modal");
        } else {
            setParentEl("body");
        }
    }, []);

    if (!parentEl) return;

    const drawVal = (sd, ed) => {
        return sd && ed ? moment(sd).format(fmtInput) + " - " + moment(ed).format(fmtInput) : "";
    };

    const handleEvent = (event, picker) => {
        if (event.type === "cancel") {
            onChange([]);
            picker.element.find("span").html();
            picker.setStartDate({});
            picker.setEndDate({});
        }
        if (event.type === "apply") {
            onChange([picker.startDate.format(fmtBackend), picker.endDate.format(fmtBackend)]);
            picker.element.find("span").html(drawVal(picker.startDate, picker.endDate));
        }
    };

    const initialSettings = {
        showDropdowns: true,
        autoUpdateInput: false,
        autoApply: true,
        showCustomRangeLabel: false,
        alwaysShowCalendars: true,
        parentEl,
        drops: "auto",
        ranges: {
            [t("Сегодня")]: [moment(), moment()],
            [t("Вчера")]: [moment().subtract(1, "days"), moment().subtract(1, "days")],
            [t("Последние 7 дней")]: [moment().subtract(6, "days"), moment()],
            [t("Последние 30 дней")]: [moment().subtract(29, "days"), moment()],
            [t("Этот месяц")]: [moment().startOf("month"), moment().endOf("month")],
            [t("Предыдущий месяц")]: [
                moment().subtract(1, "month").startOf("month"),
                moment().subtract(1, "month").endOf("month"),
            ],
        },
        locale: {
            format: fmtInput,
            applyLabel: t("Применить"),
            cancelLabel: t("Отменить"),
            daysOfWeek: [t("вс"), t("пн"), t("вт"), t("ср"), t("чт"), t("пт"), t("сб")],
            monthNames: [
                t("Январь"),
                t("Февраль"),
                t("Март"),
                t("Апрель"),
                t("Май"),
                t("Июнь"),
                t("Июль"),
                t("Август"),
                t("Сентябрь"),
                t("Октябрь"),
                t("Ноябрь"),
                t("Декабрь"),
            ],
            firstDay: 1,
        },
    };

    if (Array.isArray(value) && value[0] && value[1]) {
        initialSettings.startDate = new Date(value[0]);
        initialSettings.endDate = new Date(value[1]);
        initialSettings.autoUpdateInput = true;
    }
    if (withTime) {
        initialSettings.timePicker = true;
    }

    return (
        <DateRangePicker onEvent={handleEvent} initialSettings={initialSettings}>
            <div
                style={{
                    background: "#fff",
                    cursor: "pointer",
                    color: "#495057",
                    padding: "6px 10px",
                    border: "1px solid #ced4da",
                    width: "100%",
                    borderRadius: "0.25rem",
                }}
            >
                <Awesome type="calendar" />{" "}
                <span>{initialSettings.startDate && drawVal(new Date(value[0]), new Date(value[1]))}</span>
            </div>
        </DateRangePicker>
    );
}

export function WrapperDatePicker({
    name,
    value,
    onChange,
    readOnly,
    showTimeSelectOnly,
    // У moment и react-datepicker почему-то разные форматы дат, поэтому вынес отдельно
    fmt = "dd.MM.yyyy", // Этот - для отображения в react-datepicker
    api_fmt = "YYYY-MM-DD", // Этот - чтобы форматировать для апи
    ...props
}) {
    // https://github.com/Hacker0x01/react-datepicker

    const prepareDate = (date) => (Date.parse(date) ? moment(Date.parse(date)).format(api_fmt) : "");
    const selected = value ? moment(value, api_fmt).toDate() : "";
    const lcl = i18n.language === "ru_RU" ? ru : null;

    return (
        <DatePicker
            {...props}
            locale={lcl}
            name={name}
            showYearDropdown={!showTimeSelectOnly}
            showTimeSelectOnly={showTimeSelectOnly}
            dateFormat={fmt}
            {...(showTimeSelectOnly && { timeFormat: fmt, timeIntervals: 5 })}
            selected={selected}
            onChange={(date) => onChange(prepareDate(date))}
            readOnly={readOnly}
            showIcon={true}
            icon={
                <i
                    className="fa fa-calendar"
                    style={{ position: "absolute", top: "50%", transform: "translateY(-50%)" }}
                />
            }
            customInput={<FormControl type="text" />}
        />
    );
}

export function WrapperDateTimePicker(props) {
    return (
        <WrapperDatePicker
            {...props}
            showTimeSelect={true}
            fmt={"dd.MM.yyyy HH:mm:ss"}
            api_fmt={"YYYY-MM-DD HH:mm:ss"}
        />
    );
}

export function WrapperTimePicker(props) {
    return (
        <WrapperDatePicker
            {...props}
            showTimeSelect={true}
            showTimeSelectOnly={true}
            fmt={"HH:mm:ss"}
            api_fmt={"HH:mm:ss"}
        />
    );
}
